import { render } from "./MobileSurveyAdmin.vue?vue&type=template&id=4cbdf749&scoped=true"
import script from "./MobileSurveyAdmin.vue?vue&type=script&lang=js"
export * from "./MobileSurveyAdmin.vue?vue&type=script&lang=js"

import "@/styles/mobile-admin.css?vue&type=style&index=0&id=4cbdf749&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbdf749"]])

export default __exports__